import { Navigate } from 'react-router-dom';
import { Row, Col, Accordion } from "react-bootstrap";
import CodeCopyButton from "../Components/CodeCopyButton";
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import prism from 'react-syntax-highlighter/dist/esm/styles/prism/prism';
import { dark } from 'react-syntax-highlighter/dist/esm/styles/prism';

const LogDetail = (props) => {
    const {logID,messageLevel,traceID,application,routine,message,createdOn} = props.data;
    const {showResponseHeader,showResponseBody,showRequestHeader,showRequestBody,showInfo} = props.options;

    const filteredPaths = ['https://localhost:7151/api', 'https://bradycustomlockdevapi.azurewebsites.net/api']
    const filteredLogger = [['Microsoft.AspNetCore.HttpLogging.HttpLoggingMiddleware','HttpLogging']]
    const _application = () => {
        let _val = application;
        filteredPaths.forEach(element => {
            _val = _val.replace(element,"");
        });
        return _val;
    }

    const _routine = () => {
        let _val = routine;
        filteredLogger.forEach(element => {
            _val = _val.replace(element[0],element[1]);
        });
        return _val;
    }

    const _message = () => {
        if (message.trim().startsWith('ResponseBody:'))
            return message.replace(/^ResponseBody:/, '');

        if (message.trim().startsWith('Response:'))
            return message.replace(/^Response:/, '');

        if (message.trim().startsWith('RequestBody:'))
            return message.replace(/^RequestBody:/g, '');

        if (message.trim().startsWith('Request:'))
            return message.replace(/^Request:/g, '');

        return message;
    };
    let _shouldBeJSON = () => {
        if (message.trim().startsWith('ResponseBody:') || message.trim().startsWith('RequestBody:'))
            return true;
        return false;
    };
    let _isHeader = () => {
        if (message.startsWith('ResponseBody:')){
            _shouldBeJSON = true
            _headerModifier = 'Response Body'
            return message.replace(/^ResponseBody:/, '');
        }

        if (message.trim().startsWith('Response:') || message.trim().startsWith('Request:'))
            return true;
        return false;
    };
    let _headerModifier = () => {
        if (message.trim().startsWith('ResponseBody:'))
            return 'Response Body'

        if (message.trim().startsWith('Response:'))
            return 'Response Headers';

        if (message.trim().startsWith('RequestBody:'))
            return 'Request Body';

        if (message.trim().startsWith('Request:'))
            return 'Request Headers';
        return '';
    };

    const showMe = () => {
        if (messageLevel.trim().toLowerCase() === 'INFO' && !showInfo)
            return false;

        if (message.trim().startsWith('ResponseBody:'))
            return showRequestBody;

        if (message.trim().startsWith('Response:'))
            return showResponseHeader;

        if (message.trim().startsWith('RequestBody:'))
            return showRequestBody;

        if (message.trim().startsWith('Request:'))
            return showRequestHeader;

            return true;
    }

    return !showMe() ? '' : (
        <Row>
            <Col>
                <article>
                    <section className="errorMetaData">
                        <div>
                            <span className='data'>{messageLevel}</span>
                        </div>
                        <div>
                            <span className='data'>{createdOn.toString()}</span>
                        </div>
                        <div>
                            <span className='fieldName'>ID: </span>
                            <span className='data'>{logID}</span>
                        </div>
                        <div>
                            <span className='fieldName'>TraceID: </span>
                            <span className='data'>{traceID}</span>
                        </div>
                        <div>
                            <span className='data' title={application}>{_application()}</span>
                        </div>
                        <div>
                            <span className='data' title={routine}>{_routine() + ' ' + _headerModifier()}</span>
                        </div>
                    </section>
                    <section className='logDetails'>
                        {_shouldBeJSON ? <SyntaxHighlighter language='json' style={prism}>{_message()}</SyntaxHighlighter> :
                        <SyntaxHighlighter style={prism}>{_message()}</SyntaxHighlighter>}
                    </section>
                </article>
            </Col>
        </Row>
    )
};

export default LogDetail;